type RuntimeEnv = Record<string, string | undefined>;

type AnalyticsRuntimeConfig = {
  enableVercelObservability: boolean;
  enablePostHogSessionRecording: boolean;
  enablePostHogSurveys: boolean;
  enablePostHogExternalDependencies: boolean;
  disablePostHogRemoteFlags: boolean;
};

function isTrueFlag(value: string | undefined): boolean {
  return value === "true";
}

export function resolveAnalyticsRuntimeConfig(env: RuntimeEnv): AnalyticsRuntimeConfig {
  const isVercelRuntime = Boolean(env.NEXT_PUBLIC_VERCEL_ENV);
  const enableVercelObservability =
    isTrueFlag(env.NEXT_PUBLIC_ENABLE_VERCEL_OBSERVABILITY) || isVercelRuntime;

  return {
    enableVercelObservability,
    enablePostHogSessionRecording: isTrueFlag(env.NEXT_PUBLIC_POSTHOG_ENABLE_SESSION_RECORDING),
    enablePostHogSurveys: isTrueFlag(env.NEXT_PUBLIC_POSTHOG_ENABLE_SURVEYS),
    enablePostHogExternalDependencies: isTrueFlag(env.NEXT_PUBLIC_POSTHOG_ENABLE_EXTERNAL_DEPENDENCIES),
    disablePostHogRemoteFlags: env.NEXT_PUBLIC_POSTHOG_DISABLE_REMOTE_FLAGS !== "false",
  };
}

